import Vue from 'vue';
import Vuex from 'vuex';
import ApiService from '../services/api.service';

/*
==============================!!!!IMPORTANTE!!!!===============================
Para adicionar novos campos no dashboard é preciso atualizar em 2 lugares:
  - state
  - getters
==============================------------------===============================
Para adicionar uma nova url é preciso atualizar em 1 lugar:
  - App.vue -> script; methods; switchContext(); fazer o setter
==============================------------------===============================
Para adicionar uma nova aba no admin é preciso atualizar em 6 lugares:
  - App.vue -> script; adicionar na constante CONTEXTS o nome da aba nova
  - App.vue -> script; importar o componente
  - App.vue -> script; registrar o componente
  - App.vue -> script; computed; pegar o getter que diz que foi carregado o conteúdo
  - App.vue -> script; methods; switchContext(); fazer o setter
  - App.vue -> template; colocar o componente no html com seu "code"

------------->
  O index dos filtros é armazenado aqui porque quando o vue "des-renderiza" o
  filtro ele perde sua última escolha
                                                                <--------------
*/

Vue.use(Vuex);

// requests ===================================================================
function callApiService(url, payload = {}) {
  return new Promise((resolve) => {
    let custom_payload = payload || {};
    custom_payload.t = new Date().getTime();
    ApiService.get(url, { params: custom_payload }).then(response => {
      resolve(response.data);
    });
  });
}

// async resolvers ============================================================
async function getContext(url, payload) {
  return await callApiService(url, payload);
}

// general functions ==========================================================
let isRequesting = false;

function toogleRequesting(state) {
  isRequesting = !isRequesting;
  state.isRequesting = isRequesting;
}

export default new Vuex.Store({
  state: {
    // simple vars ============================================================
    periodTextArray: ['hoje', 'ontem', '7 dias', '15 dias', 'mês atual',
      'mês passado', 'ano atual', '1 ano', 'Intervalo de Datas'
    ],
    // general ================================================================
    isRequesting: isRequesting,
    // common =================================================================
    current_site_id: null,
    is_multi_site_manager: false,
    site_or_order_origin: [],
    stock_site_origin: [],
    current_month_name: null,
    previous_month_name: null,
    past_previous_month_name: null,
    // urls ===================================================================
    url_order_paid_orders: null,
    url_order_open_orders: null,
    url_order_cancelled_orders: null,
    url_order_billet: null,
    url_order_billet_paid: null,
    url_order_billet_open: null,
    url_order_billet_cancelled: null,
    url_order_card: null,
    url_order_card_paid: null,
    url_order_card_open: null,
    url_order_card_cancelled: null,
    url_order_pix: null,
    url_order_pix_paid: null,
    url_order_pix_open: null,
    url_order_pix_cancelled: null,
    url_order_intermediate: null,
    url_order_intermediate_paid: null,
    url_order_intermediate_open: null,
    url_order_intermediate_cancelled: null,
    url_order_current_period: null,
    // period context =========================================================
    orderPeriodSelectedIndex: 0, // mudar tbm no Filters.vue
    orderOriginSelectedIndex: 0,
    orderPeriodSelectedCode: 0,
    orderOriginSelectedCode: 0,
    orderPeriodDateStart: 0,
    orderPeriodDateEnd: 0,
    // --- API
    // --- Pedidos ---
    period_context_loaded: false,
    user_has_dashboard_permission: false,
    is_marketplace: false,
    previous_date_querystring: null,
    originOrder: [{ 'code': 1, 'label': 'Sua loja' }, { 'code': 2, 'label': 'Marketplace' }],
    show_diff: false,
    count: null,
    diff_count: null,
    diff_count_percentage: null,
    dispatched_orders: null,
    total_billed_value: null,
    customer_bill: null,
    customer_bill_percentage: null,
    average_shipping_cost: null,
    total_bucket: null,
    total_paid_orders_value: null,
    total_open_orders_value: null,
    total_cancelled_orders_value: null,
    total_paid_orders_count: null,
    total_open_orders_count: null,
    total_cancelled_orders_count: null,
    billets_count: null,
    cards_count: null,
    pix_count: null,
    intermediate_count: null,
    billets_paid_percentage: null,
    billets_open_percentage: null,
    billets_cancelled_percentage: null,
    cards_paid_percentage: null,
    cards_open_percentage: null,
    cards_cancelled_percentage: null,
    pix_paid_percentage: null,
    pix_open_percentage: null,
    pix_cancelled_percentage: null,
    intermediate_paid_percentage: null,
    intermediate_open_percentage: null,
    intermediate_cancelled_percentage: null,
    valid_percentage: null,
    paid_percentage: null,
    open_percentage: null,
    total_orders: null,
    valid_orders: null,
    paid_orders: null,
    open_orders: null,
    avg_ticket: null,
    diff_avg_ticket: null,
    diff_avg_ticket_percentage: null,
    pie_data_states: [],
    pie_data_devices: [],
    pie_data_profiles_gender: [],
    pie_data_profiles_age: [],
    profile_drilldown_series: [],
    mobile_percentage: null,
    desktop_percentage: null,
    orders_new_customers: null,
    diff_orders_new_customers: null,
    diff_orders_new_customers_percentage: null,
    orders_recurrent_customers: null,
    diff_orders_recurrent_customers: null,
    diff_orders_recurrent_customers_percentage: null,
    // For procedural use in Analytics request
    site_id: null,
    current_total_orders_value_count: null,
    current_paid_orders_count: null,
    past_paid_orders_count: null,
    past_total_orders_value_count: null,

    // --- Clientes ---
    customers: null,
    diff_customers: null,
    diff_customers_percentage: null,

    // --- Utiliza Analytics - Pedidos ---
    analytics_loaded: null,
    total_visits: null,
    diff_total_visits: null,
    total_conversion_rate: null,
    diff_total_conversion_rate: null,
    paid_conversion_rate: null,
    diff_paid_conversion_rate: null,
    line_data_page_views: [],
    visits_page_views: [],
    diff_total_conversion_rate_percentage: null,
    diff_paid_conversion_rate_percentage: null,
    diff_total_visits_percentage: null,
    // status context =========================================================
    status_context_loaded: false,
    today_count: null,
    today_value: null,
    today_ticket: null,
    today_paid_count: null,
    today_paid_value: null,
    today_paid_ticket: null,
    today_open_count: null,
    today_open_value: null,
    today_open_ticket: null,
    today_cancelled_count: null,
    today_cancelled_value: null,
    today_cancelled_ticket: null,
    yesterday_count: null,
    yesterday_value: null,
    yesterday_ticket: null,
    yesterday_paid_count: null,
    yesterday_paid_value: null,
    yesterday_paid_ticket: null,
    yesterday_open_count: null,
    yesterday_open_value: null,
    yesterday_open_ticket: null,
    yesterday_cancelled_count: null,
    yesterday_cancelled_value: null,
    yesterday_cancelled_ticket: null,
    current_month_count: null,
    current_month_value: null,
    current_month_ticket: null,
    current_month_paid_count: null,
    current_month_paid_value: null,
    current_month_paid_ticket: null,
    current_month_open_count: null,
    current_month_open_value: null,
    current_month_open_ticket: null,
    current_month_cancelled_count: null,
    current_month_cancelled_value: null,
    current_month_cancelled_ticket: null,
    previous_month_count: null,
    previous_month_value: null,
    previous_month_ticket: null,
    previous_month_paid_count: null,
    previous_month_paid_value: null,
    previous_month_paid_ticket: null,
    previous_month_open_count: null,
    previous_month_open_value: null,
    previous_month_open_ticket: null,
    previous_month_cancelled_count: null,
    previous_month_cancelled_value: null,
    previous_month_cancelled_ticket: null,
    lifetime_count: null,
    lifetime_value: null,
    lifetime_ticket: null,
    lifetime_paid_count: null,
    lifetime_paid_value: null,
    lifetime_paid_ticket: null,
    lifetime_open_count: null,
    lifetime_open_value: null,
    lifetime_open_ticket: null,
    lifetime_cancelled_count: null,
    lifetime_cancelled_value: null,
    lifetime_cancelled_ticket: null,
    // sales_products context =================================================
    productsSiteOriginSelectedIndex: 0,
    salesProductsSiteOriginSelectedIndex: 0,
    salesProductsOriginSelectedCode: 0,
    // --- API
    sales_products_context_loaded: false,
    past_month_scalable_orders_value: [],
    current_scalable_orders_value: [],
    past_month_daily_sales: [],
    current_daily_sales: [],
    monthly_sales_by_year: [],
    monthly_sales_qtd: {},
    channels_data: [],
    drilldown_series: [],
    previous_items: [],
    current_items: [],
    // bars context ===========================================================
    receipt_visits_conversion_context_loaded: false,
    semester_conversion: [],
    semester_bucket: [],
    semester_visits: [],
    bars_categories: [],
    // stock context ==========================================================
    stockSiteOriginSelectedIndex: 0,
    stockOriginSelectedCode: 0,
    // --- API
    stock_context_loaded: false,
    stock: null,
    stock_sku: null,
    minimum_stock_sku: null,
    no_stock_sku: null,
    minimum_stock_sku_products: null,
    no_stock_sku_products: null,
    stock_max_limit: null,
    url_product_sku_minimum_stock: null,
    url_product_sku_no_stock: null,
    url_product_sku_with_stock: null,
    url_product: null,
    // cancelled context ======================================================
    cancelled_context_loaded: false,
    total_cancelled_count: null,
    cancelled_sum_0: null,
    cancelled_sum_1: null,
    cancelled_sum_2: null,
    cancelled_sum_3: null,
    cancelled_sum_4: null,
    cancelled_sum_5: null,
    cancelled_len_0: null,
    cancelled_len_1: null,
    cancelled_len_2: null,
    cancelled_len_3: null,
    cancelled_len_4: null,
    cancelled_len_5: null,
    pie_data_cancelled_values: [],
    cancelled_methods_data_0: [],
    cancelled_methods_drilldown_series_0: [],
    cancelled_methods_data_1: [],
    cancelled_methods_data_2: [],
    cancelled_methods_data_3: [],
    cancelled_methods_data_4: [],
    cancelled_methods_drilldown_series_4: [],
    cancelled_methods_data_5: [],
    cancelled_methods_drilldown_series_5: [],
    dissatisfaction_count: null,
    dissatisfaction_data: [],
    // ticket progression context =============================================
    ticket_progression_context_loaded: false,
    daily_sales: [],
    min_ticket: null,
    min_date: null,
    max_ticket: null,
    max_date: null,
    average_total_daily_ticket: null,
    // abc curve context ======================================================
    abcPeriodSelectedIndex: 7, // mudar tbm no Filters.vue
    abcPeriodSelectedCode: 7,
    abcAdminPeriod: 9, // esse code tem que bater com o filtro de datas do admin do django

    // --- API
    abc_curve_context_loaded: false,
    class_a_products: [],
    class_b_products: [],
    class_c_products: [],
    class_a_resume: null,
    class_b_resume: null,
    class_c_resume: null,
    abc_graph_data_a: [],
    abc_graph_data_b: [],
    abc_graph_data_c: [],
    item_mark_a: [],
    item_mark_b: [],
    item_mark_c: [],
    // shipping costs context ======================================================
    shipping_costs_context_loaded: false,
    shipping_initial_costs: [],
    shipping_final_costs: [],
    shipping_difference_costs: []
  },
  getters: {
    // simple vars ============================================================
    periodTextArray(state) { return state.periodTextArray; },
    // components comm ========================================================
    orderPeriodSelectedCode(state) { return state.orderPeriodSelectedCode; },
    orderOriginSelectedCode(state) { return state.orderOriginSelectedCode; },
    orderPeriodDateStart(state) { return state.orderPeriodDateStart; },
    orderPeriodDateEnd(state) { return state.orderPeriodDateEnd; },
    stockOriginSelectedCode(state) { return state.stockOriginSelectedCode; },
    salesProductsOriginSelectedCode(state) { return state.salesProductsOriginSelectedCode; },
    orderPeriodSelectedIndex(state) { return state.orderPeriodSelectedIndex; },
    orderOriginSelectedIndex(state) { return state.orderOriginSelectedIndex; },
    productsSiteOriginSelectedIndex(state) { return state.productsSiteOriginSelectedIndex; },
    salesProductsSiteOriginSelectedIndex(state) { return state.salesProductsSiteOriginSelectedIndex; },
    stockSiteOriginSelectedIndex(state) { return state.stockSiteOriginSelectedIndex; },
    abcAdminPeriod(state) { return state.abcAdminPeriod; },
    // general ================================================================
    isRequesting(state) { return state.isRequesting; },
    // common =================================================================
    is_multi_site_manager(state) { return state.is_multi_site_manager; },
    site_or_order_origin(state) { return state.site_or_order_origin; },
    stock_site_origin(state) { return state.stock_site_origin; },
    current_month_name(state) { return state.current_month_name; },
    previous_month_name(state) { return state.previous_month_name; },
    past_previous_month_name(state) { return state.past_previous_month_name; },
    baseUrl(state) {
      let urlParams = new URLSearchParams(window.location.search);
      let jwtToken = urlParams.get('token');

      let tokenParts = jwtToken.split('.');
      let decodedData = JSON.parse(window.atob(tokenParts[1]));
      let debug = decodedData.debug;  // O debug é coletado do backend

      let baseUrl = debug ? "http://" + decodedData.domain + ":8000" : "https://" + decodedData.domain;

      // // Set the base URL of the API
      // let apiBaseUrl = debug ? "http://" + decodedData.domain + ":8000/api/admin/" : "https://" + decodedData.domain + "/api/admin/";

      return baseUrl;
    },
    // urls ===================================================================
    url_order_current_period(state) { return state.url_order_current_period; },
    // period context =========================================================
    // --- Pedidos ---

    total_orders_count(state) { return state.total_orders },
    total_order_paid(state) { return state.total_paid_orders_value },
    total_paid_orders_count(state) { return state.total_paid_orders_count },
    url_order_paid_orders(state) { return state.url_order_paid_orders },
    PeriodCardsObject_1(state) {
      let showDiff = state.show_diff;
      return [{
        'info': state.total_visits,
        'show_diff': showDiff,
        'diff': state.diff_total_visits_percentage,
        'diff_qtde': state.diff_total_visits,
        'bg': 'rb',
        'img': 'period/visitors.svg',
        'title': 'visitantes',
        'condition': (!state.is_multi_site_manager && !state.is_marketplace) ||
          (state.is_multi_site_manager && !state.is_marketplace && state.site_id),
        'extra_info': false
      }, {
        'info': state.orders_new_customers + ' pedidos',
        'show_diff': showDiff,
        'diff': state.diff_orders_new_customers_percentage,
        'diff_qtde': state.diff_orders_new_customers,
        'bg': 'yb',
        'img': 'period/new_customers_orders.svg',
        'title': 'de clientes novos',
        'condition': true,
        'extra_info': false
      }, {
        'info': state.count,
        'show_diff': showDiff,
        'diff': state.diff_count_percentage,
        'diff_qtde': state.diff_count,
        'bg': 'gb',
        'img': 'period/orders.svg',
        'title': 'pedidos realizados',
        'condition': true,
        'extra_info': false
      }, {
        'info': state.avg_ticket,
        'show_diff': showDiff,
        'diff': state.diff_avg_ticket_percentage,
        'diff_qtde': state.diff_avg_ticket,
        'bg': 'bb',
        'img': 'ticket.svg',
        'title': 'ticket médio',
        'condition': true,
        'extra_info': false
      }];
    },
    PeriodCardsObject_2(state) {
      let showDiff = state.show_diff;
      return [{
        'info': state.customers,
        'show_diff': showDiff,
        'diff': state.diff_customers_percentage,
        'diff_qtde': state.diff_customers,
        'bg': 'rb',
        'img': 'period/new_customers.svg',
        'title': 'novos clientes cadastrados',
        'condition': true,
        'extra_info': false
      }, {
        'info': state.orders_recurrent_customers + ' pedidos',
        'show_diff': showDiff,
        'diff': state.diff_orders_recurrent_customers_percentage,
        'diff_qtde': state.diff_orders_recurrent_customers,
        'bg': 'yb',
        'img': 'period/recurrent_customers.svg',
        'title': 'de clientes recorrentes',
        'condition': true,
        'extra_info': false
      }, {
        'info': state.total_conversion_rate,
        'show_diff': showDiff,
        'diff': state.diff_total_conversion_rate_percentage,
        'diff_qtde': state.diff_total_conversion_rate,
        'bg': 'gb',
        'img': 'period/conversion_rate.svg',
        'title': 'taxa de conversão',
        'condition': (!state.is_multi_site_manager && !state.is_marketplace) ||
          (state.is_multi_site_manager && !state.is_marketplace && state.site_id),
        'extra_info': '(sem contabilizar marketplace)'
      }, {
        'info': state.paid_conversion_rate,
        'show_diff': showDiff,
        'diff': state.diff_paid_conversion_rate_percentage,
        'diff_qtde': state.diff_paid_conversion_rate,
        'bg': 'bb',
        'img': 'period/real_conversion_rate.svg',
        'title': 'taxa de conversão real',
        'condition': (!state.is_multi_site_manager && !state.is_marketplace) ||
          (state.is_multi_site_manager && !state.is_marketplace && state.site_id),
        'extra_info': '(sem contabilizar marketplace)'
      }];
    },
    PaymentsInfoObject_1(state) {
      return [{
        'bg': 'yb',
        'info': state.total_open_orders_value,
        'url': state.url_order_open_orders,
        'label': 'em aberto',
        'count': state.total_open_orders_count
      }, {
        'bg': 'rb',
        'info': state.total_cancelled_orders_value,
        'url': state.url_order_cancelled_orders,
        'label': 'cancelados',
        'count': state.total_cancelled_orders_count
      }];
    },
    PaymentsInfoObject_2(state) {
      return [{
        'info': state.billets_count,
        'url': state.url_order_billet,
        'url_label': 'boleto',
        'img': 'period/billet_icon.svg',
        'array': [{
          'bg': 'gb',
          'info': state.billets_paid_percentage + ' pagos',
          'url': state.url_order_billet_paid
        }, {
          'bg': 'yb',
          'info': state.billets_open_percentage + ' abertos',
          'url': state.url_order_billet_open
        }, {
          'bg': 'rb',
          'info': state.billets_cancelled_percentage + ' cancelados',
          'url': state.url_order_billet_cancelled
        }]
      }, {
        'info': state.cards_count,
        'url': state.url_order_card,
        'url_label': 'cartão',
        'img': 'period/cart_icon.svg',
        'array': [{
          'bg': 'gb',
          'info': state.cards_paid_percentage + ' pagos',
          'url': state.url_order_card_paid
        }, {
          'bg': 'yb',
          'info': state.cards_open_percentage + ' abertos',
          'url': state.url_order_card_open
        }, {
          'bg': 'rb',
          'info': state.cards_cancelled_percentage + ' cancelados',
          'url': state.url_order_card_cancelled
        }]
      }, {
        'info': state.pix_count,
        'url': state.url_order_pix,
        'url_label': 'Pix',
        'img': 'period/pix_icon.svg',
        'array': [{
          'bg': 'gb',
          'info': state.pix_paid_percentage + ' pagos',
          'url': state.url_order_pix_paid
        }, {
          'bg': 'yb',
          'info': state.pix_open_percentage + ' abertos',
          'url': state.url_order_pix_open
        }, {
          'bg': 'rb',
          'info': state.pix_cancelled_percentage + ' cancelados',
          'url': state.url_order_pix_cancelled
        }]
      }, {
        'info': state.intermediate_count,
        'url': state.url_order_intermediate,
        'url_label': 'Outros',
        'img': 'period/total_bucket_card.svg',
        'array': [{
          'bg': 'gb',
          'info': state.intermediate_paid_percentage + ' pagos',
          'url': state.url_order_intermediate_paid
        }, {
          'bg': 'yb',
          'info': state.intermediate_open_percentage + ' abertos',
          'url': state.url_order_intermediate_open
        }, {
          'bg': 'rb',
          'info': state.intermediate_cancelled_percentage + ' cancelados',
          'url': state.url_order_intermediate_cancelled
        }]
      }];
    },
    ShippingsCardsObject(state) {
      return [{
        'bg': 'gb',
        'info': state.dispatched_orders,
        'img': 'shippings/dispatched_orders.svg',
        'title': 'pedidos despachados'
      }, {
        'bg': 'yb',
        'info': state.total_billed_value,
        'img': 'shippings/billed_value.svg',
        'title': 'valor faturado'
      }, {
        'bg': 'rb',
        'info': state.customer_bill + ' (' + state.customer_bill_percentage + ')',
        'img': 'shippings/customer_shipping_paid.svg',
        'title': 'frete pago pelo cliente'
      }, {
        'bg': 'bb',
        'info': state.average_shipping_cost,
        'img': 'ticket.svg',
        'title': 'valor médio de frete'
      }];
    },
    period_context_loaded(state) { return state.period_context_loaded; },
    user_has_dashboard_permission(state) { return state.user_has_dashboard_permission; },
    is_marketplace(state) { return state.is_marketplace; },
    previous_date_querystring(state) { return state.previous_date_querystring; },
    originOrder(state) { return state.originOrder; },
    total_bucket(state) { return state.total_bucket; },
    pie_data_states(state) { return state.pie_data_states; },
    pie_data_devices(state) { return state.pie_data_devices; },
    pie_data_profiles_gender(state) { return state.pie_data_profiles_gender; },
    pie_data_profiles_age(state) { return state.pie_data_profiles_age; },
    profile_drilldown_series(state) { return state.profile_drilldown_series; },
    mobile_percentage(state) { return state.mobile_percentage; },
    desktop_percentage(state) { return state.desktop_percentage; },
    // For procedural use in Analytics request
    site_id(state) { return state.site_id; },
    current_total_orders_value_count(state) { return state.current_total_orders_value_count; },
    current_paid_orders_count(state) { return state.current_paid_orders_count; },
    past_paid_orders_count(state) { return state.past_paid_orders_count; },
    past_total_orders_value_count(state) { return state.past_total_orders_value_count; },
    // --- Utiliza Analytics - Pedidos ---
    analytics_loaded(state) { return state.analytics_loaded; },
    line_data_page_views(state) { return state.line_data_page_views; },
    visits_page_views(state) { return state.visits_page_views; },
    // status context =====================================================
    status_context_loaded(state) { return state.status_context_loaded; },
    StatusInfoObject(state) {
      return [
        ['Todos os pedidos', [{
          'has_style': true,
          'title': 'Hoje',
          'qtd': state.today_count,
          'value': state.today_value,
          'ticket': state.today_ticket
        }, {
          'has_style': false,
          'title': 'Ontem',
          'qtd': state.yesterday_count,
          'value': state.yesterday_value,
          'ticket': state.yesterday_ticket
        }, {
          'has_style': false,
          'title': 'Mês atual',
          'qtd': state.current_month_count,
          'value': state.current_month_value,
          'ticket': state.current_month_ticket
        }, {
          'has_style': false,
          'title': 'Mês anterior',
          'qtd': state.previous_month_count,
          'value': state.previous_month_value,
          'ticket': state.previous_month_ticket
        }, {
          'has_style': false,
          'title': 'Lifetime',
          'qtd': state.lifetime_count,
          'value': state.lifetime_value,
          'ticket': state.lifetime_ticket
        }, ]],
        ['Pedidos pagos', [{
          'has_style': true,
          'title': 'Hoje',
          'qtd': state.today_paid_count,
          'value': state.today_paid_value,
          'ticket': state.today_paid_ticket
        }, {
          'has_style': false,
          'title': 'Ontem',
          'qtd': state.yesterday_paid_count,
          'value': state.yesterday_paid_value,
          'ticket': state.yesterday_paid_ticket
        }, {
          'has_style': false,
          'title': 'Mês atual',
          'qtd': state.current_month_paid_count,
          'value': state.current_month_paid_value,
          'ticket': state.current_month_paid_ticket
        }, {
          'has_style': false,
          'title': 'Mês anterior',
          'qtd': state.previous_month_paid_count,
          'value': state.previous_month_paid_value,
          'ticket': state.previous_month_paid_ticket
        }, {
          'has_style': false,
          'title': 'Lifetime',
          'qtd': state.lifetime_paid_count,
          'value': state.lifetime_paid_value,
          'ticket': state.lifetime_paid_ticket
        }, ]],
        ['Pedidos em aberto', [{
          'has_style': true,
          'title': 'Hoje',
          'qtd': state.today_open_count,
          'value': state.today_open_value,
          'ticket': state.today_open_ticket
        }, {
          'has_style': false,
          'title': 'Ontem',
          'qtd': state.yesterday_open_count,
          'value': state.yesterday_open_value,
          'ticket': state.yesterday_open_ticket
        }, {
          'has_style': false,
          'title': 'Mês atual',
          'qtd': state.current_month_open_count,
          'value': state.current_month_open_value,
          'ticket': state.current_month_open_ticket
        }, {
          'has_style': false,
          'title': 'Mês anterior',
          'qtd': state.previous_month_open_count,
          'value': state.previous_month_open_value,
          'ticket': state.previous_month_open_ticket
        }, {
          'has_style': false,
          'title': 'Lifetime',
          'qtd': state.lifetime_open_count,
          'value': state.lifetime_open_value,
          'ticket': state.lifetime_open_ticket
        }, ]],
        ['Pedidos cancelados', [{
          'has_style': true,
          'title': 'Hoje',
          'qtd': state.today_cancelled_count,
          'value': state.today_cancelled_value,
          'ticket': state.today_cancelled_ticket
        }, {
          'has_style': false,
          'title': 'Ontem',
          'qtd': state.yesterday_cancelled_count,
          'value': state.yesterday_cancelled_value,
          'ticket': state.yesterday_cancelled_ticket
        }, {
          'has_style': false,
          'title': 'Mês atual',
          'qtd': state.current_month_cancelled_count,
          'value': state.current_month_cancelled_value,
          'ticket': state.current_month_cancelled_ticket
        }, {
          'has_style': false,
          'title': 'Mês anterior',
          'qtd': state.previous_month_cancelled_count,
          'value': state.previous_month_cancelled_value,
          'ticket': state.previous_month_cancelled_ticket
        }, {
          'has_style': false,
          'title': 'Lifetime',
          'qtd': state.lifetime_cancelled_count,
          'value': state.lifetime_cancelled_value,
          'ticket': state.lifetime_cancelled_ticket
        }, ]]
      ];
    },
    // sales_products context ======================================================
    sales_products_context_loaded(state) { return state.sales_products_context_loaded; },
    past_month_scalable_orders_value(state) { return state.past_month_scalable_orders_value; },
    current_scalable_orders_value(state) { return state.current_scalable_orders_value; },
    past_month_daily_sales(state) { return state.past_month_daily_sales; },
    current_daily_sales(state) { return state.current_daily_sales; },
    years_keys(state) { return state.years_keys; },
    monthly_sales_by_year(state) { return state.monthly_sales_by_year; },
    monthly_sales_qtd(state) { return state.monthly_sales_qtd; },
    channels_data(state) { return state.channels_data; },
    drilldown_series(state) { return state.drilldown_series; }, // highcharts
    previous_items(state) { return state.previous_items; },
    current_items(state) { return state.current_items; },
    // bars context =======================================================
    receipt_visits_conversion_context_loaded(state) { return state.receipt_visits_conversion_context_loaded; },
    semester_conversion(state) { return state.semester_conversion; },
    semester_bucket(state) { return state.semester_bucket; },
    semester_visits(state) { return state.semester_visits; },
    bars_categories(state) { return state.bars_categories; },
    // stock context ======================================================
    stock_context_loaded(state) { return state.stock_context_loaded; },
    StockInfoObject(state) {
      return [{
        'bg': 'gb',
        'info': state.stock,
        'img': 'stock/items.svg',
        'title': 'itens em estoque',
        'url': state.url_product
      }, {
        'bg': 'bb',
        'info': state.stock_sku,
        'img': 'stock/skus.svg',
        'title': 'skus com estoque',
        'url': state.url_product_sku_with_stock
      }, {
        'bg': 'yb',
        'info': state.minimum_stock_sku,
        'img': 'stock/minimum_stock.svg',
        'title': 'skus em estoque mínimo',
        'url': state.url_product_sku_minimum_stock
      }, {
        'bg': 'rb',
        'info': state.no_stock_sku,
        'img': 'stock/no_stock.svg',
        'title': 'skus sem estoque',
        'url': state.url_product_sku_no_stock
      }];
    },
    minimum_stock_sku_products(state) { return state.minimum_stock_sku_products; },
    no_stock_sku_products(state) { return state.no_stock_sku_products; },
    stock_max_limit(state) { return state.stock_max_limit; },
    // cancelled context ==================================================
    cancelled_context_loaded(state) { return state.cancelled_context_loaded; },
    cancelled_sum_0(state) { return state.cancelled_sum_0; },
    total_cancelled_count(state) { return state.total_cancelled_count; },
    cancelled_sum_1(state) { return state.cancelled_sum_1; },
    cancelled_sum_2(state) { return state.cancelled_sum_2; },
    cancelled_sum_3(state) { return state.cancelled_sum_3; },
    cancelled_sum_4(state) { return state.cancelled_sum_4; },
    cancelled_sum_5(state) { return state.cancelled_sum_5; },
    cancelled_len_0(state) { return state.cancelled_len_0; },
    cancelled_len_1(state) { return state.cancelled_len_1; },
    cancelled_len_2(state) { return state.cancelled_len_2; },
    cancelled_len_3(state) { return state.cancelled_len_3; },
    cancelled_len_4(state) { return state.cancelled_len_4; },
    cancelled_len_5(state) { return state.cancelled_len_5; },
    pie_data_cancelled_values(state) { return state.pie_data_cancelled_values; },
    cancelled_methods_data_0(state) { return state.cancelled_methods_data_0; },
    cancelled_methods_drilldown_series_0(state) { return state.cancelled_methods_drilldown_series_0; },
    cancelled_methods_data_1(state) { return state.cancelled_methods_data_1; },
    cancelled_methods_data_2(state) { return state.cancelled_methods_data_2; },
    cancelled_methods_data_3(state) { return state.cancelled_methods_data_3; },
    cancelled_methods_data_4(state) { return state.cancelled_methods_data_4; },
    cancelled_methods_drilldown_series_4(state) { return state.cancelled_methods_drilldown_series_4; },
    cancelled_methods_data_5(state) { return state.cancelled_methods_data_5; },
    cancelled_methods_drilldown_series_5(state) { return state.cancelled_methods_drilldown_series_5; },
    dissatisfaction_count(state) { return state.dissatisfaction_count; },
    dissatisfaction_data(state) { return state.dissatisfaction_data; },
    // ticket progression context =========================================
    ticket_progression_context_loaded(state) { return state.ticket_progression_context_loaded; },
    TicketProgressionObject(state) {
      return [{
        'info': state.average_total_daily_ticket,
        'title': 'média dos dias',
        'bg': 'yb',
        'img': 'ticket_progression/avg_ticket_progression.svg'
      }, {
        'info': state.min_ticket,
        'title': 'menor ticket médio real (' + state.min_date + ')',
        'bg': 'bb',
        'img': 'ticket_progression/min_ticket.svg'
      }, {
        'info': state.max_ticket,
        'title': 'maior ticket médio real (' + state.max_date + ')',
        'bg': 'gb',
        'img': 'ticket_progression/max_ticket.svg'
      }];
    },
    daily_sales(state) { return state.daily_sales; },
    min_ticket(state) { return state.min_ticket; },
    min_date(state) { return state.min_date; },
    max_ticket(state) { return state.max_ticket; },
    max_date(state) { return state.max_date; },
    average_total_daily_ticket(state) { return state.average_total_daily_ticket; },
    // abc curve context ======================================================
    abcPeriodSelectedIndex(state) { return state.abcPeriodSelectedIndex; },
    abcPeriodSelectedCode(state) { return state.abcPeriodSelectedCode; },
    abc_curve_context_loaded(state) { return state.abc_curve_context_loaded; },
    abc_graph_data_a(state) { return state.abc_graph_data_a; },
    abc_graph_data_b(state) { return state.abc_graph_data_b; },
    abc_graph_data_c(state) { return state.abc_graph_data_c; },
    item_mark_a(state) { return state.item_mark_a; },
    item_mark_b(state) { return state.item_mark_b; },
    item_mark_c(state) { return state.item_mark_c; },
    ClassProductObject(state) {
      return [{
        'info': state.class_a_products,
        'resume': state.class_a_resume,
        'title': 'Curva A - 20% dos produtos',
        'bg': 'gb',
        'bullet': '\u25CF',
        'color': '#7ABA1E',
        'img_color': 'filter: invert(82%) sepia(17%) saturate(7028%) hue-rotate(36deg) brightness(91%) contrast(76%);'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }, {
        'info': state.class_b_products,
        'resume': state.class_b_resume,
        'title': 'Curva B - 30% dos produtos',
        'bg': 'bb',
        'bullet': '\u25C6',
        'color': '#0BA7DA',
        'img_color': 'filter: invert(45%) sepia(85%) saturate(1686%) hue-rotate(162deg) brightness(98%) contrast(91%)'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }, {
        'info': state.class_c_products,
        'resume': state.class_c_resume,
        'title': 'Curva C - 50% dos produtos',
        'bg': 'yb',
        'bullet': '\u25A0',
        'color': '#FCBC2C',
        'img_color': 'filter: invert(91%) sepia(17%) saturate(7273%) hue-rotate(336deg) brightness(106%) contrast(98%)'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }];
    },
    // shipping costs context ======================================================
    shipping_costs_context_loaded(state) { return state.shipping_costs_context_loaded },
    ShippingCostsObject(state) {
      return [{
        'info': state.shipping_initial_costs,
        'title': 'Fretes por valores de cotação',
        'bg': 'gb',
        'color': '#7ABA1E',
        'img_color': 'filter: invert(82%) sepia(17%) saturate(7028%) hue-rotate(36deg) brightness(91%) contrast(76%);'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }, {
        'info': state.shipping_final_costs,
        'title': 'Fretes por valores cobrados',
        'bg': 'bb',
        'color': '#0BA7DA',
        'img_color': 'filter: invert(45%) sepia(85%) saturate(1686%) hue-rotate(162deg) brightness(98%) contrast(91%)'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }, {
        'info': state.shipping_difference_costs,
        'title': 'Fretes com maior diferença entre frete cotado e frete cobrado',
        'bg': 'yb',
        'color': '#FCBC2C',
        'img_color': 'filter: invert(91%) sepia(17%) saturate(7273%) hue-rotate(336deg) brightness(106%) contrast(98%)'
          // https://codepen.io/sosuke/pen/Pjoqqp
      }]
    }
  },
  mutations: {
    // components comm ====================================================
    updatePeriodOriginSelectedIndex(state, payload) {
      state.orderPeriodSelectedIndex = payload.period;
      state.orderOriginSelectedIndex = payload.origin;
      state.orderPeriodDateStart = payload.date_start;
      state.orderPeriodDateEnd = payload.date_end;
    },
    updateSalesProductsSiteOriginSelectedIndex(state, payload) { state.salesProductsSiteOriginSelectedIndex = payload; },
    updateStockSiteOriginSelectedIndex(state, payload) { state.stockSiteOriginSelectedIndex = payload; },
    updateOrderPeriodSelectedCode(state, payload) { state.orderPeriodSelectedCode = payload; },
    updateOriginSelectedCode(state, payload) { state.orderOriginSelectedCode = payload; },
    updateStockOriginSelectedCode(state, payload) { state.stockOriginSelectedCode = payload; },
    updateSalesProductsOriginSelectedCode(state, payload) { state.salesProductsOriginSelectedCode = payload; },
    updateAbcPeriodSelectedCode(state, payload) { state.orderPeriodSelectedCode = payload; },
    updateAbcAdminPeriod(state, payload) { state.abcAdminPeriod = payload; },
    // load on demand =====================================================
    requestPeriodContext(state) {
      toogleRequesting(state);
      getContext('site/dashboard/site/').then(siteResponse => {
        Object.keys(siteResponse).forEach(index => {
          state[index] = siteResponse[index];
        });
      }).catch(err => {
        console.log(err);
      });
      getContext(
        'order/dashboard/order_period_context/', { 'period': state.orderPeriodSelectedIndex, 'first_request': true }
      ).then(orderResponse => {
        getContext(
          'customer/dashboard/customer/', {
            'period': state.orderPeriodSelectedIndex,
          }
        ).then(customerResponse => {
          Object.keys(orderResponse).forEach(index => {
            state[index] = orderResponse[index];
          });
          Object.keys(customerResponse).forEach(index => {
            state[index] = customerResponse[index];
          });
          toogleRequesting(state);
          if ((!state.is_multi_site_manager && !state.is_marketplace) || (state.is_multi_site_manager && !state.is_marketplace && state.site_id)) {
            getContext(
              'order/dashboard/order_request_remaining_dashboard_analytics/', {
                't': new Date().getTime(),
                'period': state.orderPeriodSelectedIndex,
                'values': {
                  'site_id': state.site_id,
                  'current_total_orders_value_count': state.current_total_orders_value_count,
                  'current_paid_orders_count': state.current_paid_orders_count,
                  'past_paid_orders_count': state.past_paid_orders_count,
                  'past_total_orders_value_count': state.past_total_orders_value_count,
                },
                'date_start': state.orderPeriodDateStart,
                'date_end': state.orderPeriodDateEnd,
              }
            ).then(analyticsResponse => {
              Object.keys(analyticsResponse).forEach(index => {
                state[index] = analyticsResponse[index];
              });
            }).catch(err => {
              console.log(err);
            });
          }
        }).catch(err => {
          console.log(err);
        });
      }).catch(err => {
        console.log(err);
      });
    },
    requestCommonContext(state, obj) {
      toogleRequesting(state);
      getContext(obj.url, { 'period': obj.period }).then(response => {
        Object.keys(response).forEach(index => {
          state[index] = response[index];
        });
      }).catch(err => {
        console.log(err);
      });
    },
    // filters api requests ===============================================
    updateOrderPeriodContext(state, payload) {
      let custom_payload = payload || {};
      custom_payload.t = new Date().getTime();
      new Promise(() => {
        ApiService.get('order/dashboard/order_period_context/', {
          params: custom_payload,
        }).then(orderResponse => {
          new Promise(() => {
            ApiService.get('customer/dashboard/customer/', {
              params: custom_payload,
            }).then(customerResponse => {
              Object.keys(orderResponse.data).forEach(index => {
                state[index] = orderResponse.data[index];
              });
              Object.keys(customerResponse.data).forEach(index => {
                state[index] = customerResponse.data[index];
              });
              if ((!state.is_multi_site_manager && !state.is_marketplace) || (state.is_multi_site_manager && !state.is_marketplace && state.site_id)) {
                new Promise(() => {
                  ApiService.get('order/dashboard/order_request_remaining_dashboard_analytics/', {
                    params: {
                      't': new Date().getTime(),
                      'period': this.state.orderPeriodSelectedIndex,
                      'values': {
                        'site_id': this.state.site_id,
                        'current_total_orders_value_count': this.state.current_total_orders_value_count,
                        'current_paid_orders_count': this.state.current_paid_orders_count,
                        'past_paid_orders_count': this.state.past_paid_orders_count,
                        'past_total_orders_value_count': this.state.past_total_orders_value_count,
                      },
                      'date_start': this.state.orderPeriodDateStart,
                      'date_end': this.state.orderPeriodDateEnd,
                    }
                  }).then(analyticsResponse => {
                    Object.keys(analyticsResponse.data).forEach(index => {
                      state[index] = analyticsResponse.data[index];
                    });
                  }).catch(err => {
                    console.log(err);
                  });
                });
              }
            }).catch(err => {
              console.log(err);
            });
          });
        }).catch(err => {
          console.log(err);
        });
      });
    },
    updateCommonContext(state, obj) {
      new Promise(() => {
        let custom_payload = obj.payload || {};
        custom_payload.t = new Date().getTime();
        ApiService.get(obj.url, { params: custom_payload }).then(response => {
          Object.keys(response.data).forEach(index => {
            state[index] = response.data[index];
          });
        }).catch(err => {
          console.log(err);
        });
      });
    }
  }
});